module.exports = __webpack_public_path__ + "img/collar_button_diameter.7da0c083.png";